import * as categories from './_categories';
import * as profiles from './_profiles';
import * as users from './_users';
import * as subscriptions from './_subscriptions';
import * as transactions from './_transactions';
import * as providers from './_providers';
import * as facilities from './_facilities';
import * as products from './_products';
import * as purchases from './_purchases';
import * as integrations from './_integrations';
import * as participants from './_participants';
import * as paymentMethods from './_paymentMethods';
import * as crawlings from './_crawlings';
import * as activities from './_activities';
import * as seasonalcourts from './_seasonalcourts';
import * as overview from './_overview';
import * as confirmationEmail from './_confirmationEmail';
import * as signups from './_signups';
import * as automatedBookingAgreements from './_automatedBookingAgreements';
import * as resources from './_resources';
import * as relayRules from './_relayRules';
import * as lockers from './_lockers';
import * as areas from './_areas';
import * as providerAdmin from './_providerAdmin';
import * as externalPurchaseAttempt from './_externalPurchaseAttempt';
import * as externalPurchase from './_externalPurchase';
import * as facilityRedirects from './_facilityRedirects';
import * as proxies from './_proxies';
import * as seoTexts from './_seoExtraData';
import * as facilityContent from './_facilityContent';
import * as externalActivities from './_externalActivities';
import * as nonPartnerFacilities from './_nonPartnerFacilities';
import * as ambassadorApplications from './_ambassadorApplications';
import * as playReport from './_playReport';
import * as playEvents from './_playEvents';
import * as playGames from './_playGames';
import * as saltoMasterCodes from './_saltoMasterCodes';
import * as marketingConsent from './_marketingConsent';
import * as clubhouseAdmin from './_clubhouseAdmin';

const formerApi = {
  categories,
  profiles,
  users,
  subscriptions,
  transactions,
  providers,
  facilities,
  facilityContent,
  products,
  purchases,
  integrations,
  participants,
  paymentMethods,
  crawlings,
  activities,
  seasonalcourts,
  overview,
  confirmationEmail,
  signups,
  automatedBookingAgreements,
  relayRules,
  resources,
  lockers,
  areas,
  providerAdmin,
  externalPurchaseAttempt,
  externalPurchase,
  facilityRedirects,
  proxies,
  seoTexts,
  externalActivities,
  nonPartnerFacilities,
  ambassadorApplications,
  playReport,
  playEvents,
  playGames,
  saltoMasterCodes,
  marketingConsent,
  clubhouseAdmin
};

export { formerApi };
